import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
// i18n
import "./utils/i18n";

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById("root")
);
